import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import SejaParceiroPage from "@/pages/SejaParceiroPage";

export const Route = createFileRoute("/seja-parceiro")({
  head: () => seoHead({
    title: "Seja Parceiro | Shopping do Bem",
    description: "Cadastre sua loja no Shopping do Bem e transforme vendas em doações para causas sociais.",
    path: "/seja-parceiro",
  }),
  component: SejaParceiroPage,
});
